import * as yup from "yup";

// Multi-language messages
const messages = {
  en: {
    requiredPhone: "Phone number is required",
    invalidPhone: "Invalid phone number",
    requiredFirstName: "First name is required",
    requiredLastName: "Last name is required",
    requiredEmail: "Email is required",
    invalidEmail: "Invalid email",
    requiredCompany: "Company is required",
  },
  fr: {
    requiredPhone: "Numéro de téléphone est requis",
    invalidPhone: "Numéro de téléphone invalide",
    requiredFirstName: "Le prénom est requis",
    requiredLastName: "Le nom est requis",
    requiredEmail: "Email est requis",
    invalidEmail: "Email invalide",
    requiredCompany: "Entreprise est requis",
  },
  ar: {
    requiredPhone: "رقم الهاتف مطلوب",
    invalidPhone: "رقم الهاتف غير صالح",
    requiredFirstName: "الاسم الأول مطلوب",
    requiredLastName: "اسم العائلة مطلوب",
    requiredEmail: "البريد الإلكتروني مطلوب",
    invalidEmail: "البريد الإلكتروني غير صالح",
    requiredCompany: "الشركة مطلوبة",
  },
};

// Phone + name (when full prospect identification is off; email/company stay optional)
export const getCompleterPhoneSchema = (lang = "en") => {
  const msg = messages[lang];
  return yup.object().shape({
    first_name: yup.string().trim().required(msg.requiredFirstName),
    last_name: yup.string().trim().required(msg.requiredLastName),
    phone: yup
      .string()
      .matches(/^[+]\d{1,3}-?\d+$/, msg.invalidPhone)
      .required(msg.requiredPhone),
  });
};

// Full completer form schema
export const completerFormSchemaWithLang = (lang = "en") => {
  const msg = messages[lang];
  return yup.object().shape({
    first_name: yup.string().trim().required(msg.requiredFirstName),
    last_name: yup.string().trim().required(msg.requiredLastName),
    email: yup.string().email(msg.invalidEmail).required(msg.requiredEmail),
    company: yup.string().required(msg.requiredCompany),
    phone: yup
      .string()
      .matches(/^[+]\d{1,3}-?\d+$/, msg.invalidPhone)
      .required(msg.requiredPhone),
  });
};
